import EngagementReport from 'modules/engagement_report/engagement_reports/EngagementReport'
import React from 'react'

function SlotBookingEngagement() {
  return (
    <div>
      <EngagementReport slotBooking={true}  />
    </div>
  )
}

export default SlotBookingEngagement
